import { createSlice } from '@reduxjs/toolkit';
import { prospectDocument } from '@repo/backoffice-api';

const initialState: prospectDocument = {
  id: '',
  storageKey: '',
  status: '',
  documentType: '',
  title: '',
  required: false,
  generatedAt: '',
};

export const documentDataSlice = createSlice({
  name: 'documentData',
  initialState,
  reducers: {
    setDocumentData: (state, action: { payload: prospectDocument }) => ({
      ...state,
      ...action.payload,
    }),
    resetDocumentData: () => initialState,
  },
});

export const { setDocumentData, resetDocumentData } = documentDataSlice.actions;

export default documentDataSlice.reducer;
